import { useQuery } from "@tanstack/react-query";

import type { API } from "simplydo/core/api";
import type { UserMe } from "simplydo/interfaces/types/userTypes";

/**
 * Observes the signed-in user. Login, session resume, and ghosting write this
 * cache entry; `api.invalidateQueries(api.users.me)` refetches it.
 *
 * The observer is only enabled while a user is cached. Logout leaves the entry
 * invalidated, so an enabled observer would refetch `/users/me` without a
 * token and trigger another logout.
 */
export const useCurrentUser = (api: API): UserMe | null => {
  const { data } = useQuery<UserMe | null>(
    {
      queryKey: api.currentUserQueryKey(),
      enabled: (query) => query.state.data != null,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
    api.queryClient,
  );
  return data ?? null;
};
